import React, { useCallback, useEffect, useState } from 'react';
import { Box } from '@cad-arc';
import { useLocation, useNavigate } from 'react-router-dom';
import { DexFormView, DexDispatcherFormEnumType } from '@mark43/cad-api';
import { DexFormsPanelBody } from '../data-exchange/forms/dex-forms-panel';
import { DexFormPanelBody } from '../data-exchange/forms/dex-form-panel';
import { useDexFormsQuery } from '../data-exchange/forms/use-dex-forms-query';
import { useDexFormView } from '../data-exchange/forms/use-dex-form-view';
import { getDexDefaultForm } from './utils';
import { useDexResults } from '../data-exchange/results/use-dex-results';

export function FrDexNewSearchSection() {
    const { dexResultsStore } = useDexResults();
    const [dexDispatcherForm, setDexDispatcherForm] = useState<
        DexDispatcherFormEnumType | undefined
    >(dexResultsStore.initialFrDexFormType);

    const { data } = useDexFormsQuery();
    const dexFormsResponse = useDexFormView({ dexFormsResponse: data });
    const { state, pathname } = useLocation();
    const navigate = useNavigate();

    useEffect(
        function handleDefaultDexFormSet() {
            if (dexFormsResponse && !dexDispatcherForm) {
                const defaultForm = state?.tab ?? getDexDefaultForm(dexFormsResponse);
                if (defaultForm) {
                    setDexDispatcherForm(defaultForm);
                }
            } else if (dexDispatcherForm && state?.tab && dexDispatcherForm !== state?.tab) {
                setDexDispatcherForm(state?.tab);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [dexFormsResponse, state?.tab]
    );

    useEffect(
        function clearRouterStateAfterFormChange() {
            if (state?.tab) {
                navigate(pathname, { replace: true }); // This clears the state but stays on the same page
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [dexDispatcherForm]
    );

    const selectForm = useCallback(function handleFormSelect(form: DexFormView) {
        return () => {
            setDexDispatcherForm(form.dexDispatcherForm);
        };
    }, []);

    return (
        <>
            <Box
                width="20%"
                borderRight="var(--arc-borders-sm)"
                borderRightColor="var(--arc-colors-border-default)"
                overflowY="auto"
            >
                <DexFormsPanelBody
                    selectedDispatcherFormType={dexDispatcherForm}
                    getOpenDexFormPanel={selectForm}
                />
            </Box>
            {dexDispatcherForm && (
                <DexFormPanelBody
                    dexFormsResponse={dexFormsResponse!}
                    dexForm={dexDispatcherForm}
                    dexFormEventPanelPrefillValues={dexResultsStore.frDexPrefillValues}
                />
            )}
        </>
    );
}
